import type { EnvironmentDecorItemConfig } from "@/scene/SceneProps";
import type { UnderwaterVisualSettingsOverride } from "@/scene/VisualSettings";
import {
  ASSORTED_ROCK_MODELS,
  CLARET_WIGGLE_SEAWEED_MODEL,
  LOG_MODEL,
  ROCK_FORMAT2_MODEL,
  ROCK_MODEL,
  WAGON_WHEEL_MODEL,
} from "./shared";

export const CATFISH_ENVIRONMENT_DECOR: EnvironmentDecorItemConfig[] = [
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: -2.3, y: -2.6, z: -1.15 },
    rotation: { x: 0, y: 0.42, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.58,
    position: { x: 1.65, y: -2.28, z: -0.9 },
    rotation: { x: 0, y: -0.7, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.52,
    position: { x: 0.88, y: -2.29, z: 1.18 },
    rotation: { x: 0, y: 2.35, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.44,
    position: { x: -1.05, y: -2.3, z: 1.02 },
    rotation: { x: 0, y: 1.65, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 1.35,
    position: { x: -0.18, y: -2.28, z: 1.62 },
    rotation: { x: 0.04, y: -0.78, z: 0.06 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 0.04, y: -2.45, z: -3.6 },
    rotation: { x: -3.142, y: 1.396, z: -3.142 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 0.18, y: -2.28, z: 3 },
    rotation: { x: 0, y: -0.524, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 3, y: -2, z: 0.36 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 1.07,
    position: { x: 2, y: -2.27, z: 2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CLARET_WIGGLE_SEAWEED_MODEL,
    targetSize: 0.7,
    position: { x: -3.1, y: -2.55, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2.45, y: 3.75, z: 3 },
  },
  {
    model: CLARET_WIGGLE_SEAWEED_MODEL,
    targetSize: 0.7,
    position: { x: -2.8, y: -2.3, z: 0 },
    rotation: { x: -2.582, y: 1.425, z: 2.601 },
    scale: { x: 1.55, y: 1.7, z: 1.3 },
  },
  {
    model: WAGON_WHEEL_MODEL,
    targetSize: 0.7,
    position: { x: 0, y: -2.28, z: -2.3 },
    rotation: { x: -1.467, y: -0.059, z: 0.35 },
    scale: { x: 2.3, y: 2.25, z: 2.25 },
  },
  {
    model: LOG_MODEL,
    targetSize: 0.7,
    position: { x: -2, y: -2.9, z: -4.3 },
    rotation: { x: 0, y: -0.873, z: 0 },
    scale: { x: 6.9, y: 10.4, z: 6.9 },
  },
  {
    model: ASSORTED_ROCK_MODELS[28],
    targetSize: 0.7,
    position: { x: -2.5, y: -2.4, z: -0.7 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.25, y: 2, z: 1.1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 2, y: -2.95, z: -3.2 },
    rotation: { x: 0, y: -0.873, z: 0 },
    scale: { x: 2.95, y: 4.55, z: 2.05 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 1, y: -2.4, z: -2.5 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CLARET_WIGGLE_SEAWEED_MODEL,
    targetSize: 0.7,
    position: { x: 0.8, y: -2.45, z: -3.35 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.15, y: 2.15, z: 1.65 },
  },
];

export const CATFISH_VISUAL_SETTINGS: UnderwaterVisualSettingsOverride = {
  toneExposure: 1.14,
  environmentIntensity: 1.02,
  ambientIntensity: 0.84,
  ambientColor: "#bffaff",
  hemisphereIntensity: 1.29,
  hemisphereSkyColor: "#65e9ff",
  hemisphereGroundColor: "#075c7a",
  keyIntensity: 2.24,
  keyColor: "#fff4d7",
  fillIntensity: 1.94,
  fillColor: "#20dfff",
  rimIntensity: 1.07,
  rimColor: "#b6fdff",
  shimmerIntensity: 1.08,
  shimmerColor: "#29eaff",
  cameraFillIntensity: 1.85,
  cameraFillColor: "#c8fbff",
  causticsOpacity: 0.59,
  causticsScale: 0.73,
  causticsSpeed: 0.35,
  causticsIntensity: 0.75,
  causticsDeepColor: "#04506f",
  causticsShallowColor: "#12bad2",
  causticsHighlightColor: "#b8fff0",
  causticsSurfaceGlowColor: "#039fbd",
  causticsRadiusScale: 1.59,
  surfaceGlowIntensity: 0,
  lightRaysOpacity: 0.24,
  lightRaysColor: "#c8ffff",
  lightRaysWidth: 1.35,
  lightRaysLength: 1,
  lightRaysVerticalOffset: 0.5,
  lightRaysSpeed: 1.95,
  lightRaysCount: 30,
  bubbleCount: 250,
  bubbleSize: 1,
  bubbleOpacity: 0.19,
  bubbleSpeed: 0.14,
  bubbleDrift: 0.78,
  bubbleSpread: 0.91,
  particleCount: 1200,
  particleSize: 2.66,
  particleOpacity: 0.86,
  particleSpeed: 0.16,
  particleDrift: 1,
  particleSpread: 1.25,
  depthFogDensity: 0.054,
  waterGradientOpacity: 0.43,
  waterGradientTopIntensity: 1.28,
  waterGradientBottomIntensity: 1,
  waterGradientHeight: -2.3,
  waterSurfaceColor: "#0f625e",
  pollutionColor: "#798b60",
  waterSurfaceOpacity: 0.78,
  waterSurfaceHeight: 6.4,
  waterSurfaceWaveStrength: 0.18,
  waterSurfaceWaveScale: 1.36,
  waterSurfaceWaveSpeed: 0.78,
  floorOpacity: 0.96,
  seabedRadius: 1.71,
  seabedDepth: 0,
  seabedMurkiness: 0.72,
  seabedTextureScale: 1.65,
  seabedCaustics: 0.46,
  seabedRelief: 1.45,
  seaweedCount: 480,
  seaweedArea: 1.93,
  seaweedColor: "#07b687",
  seaweedTipColor: "#28d283",
  seaweedHeight: 0.71,
  seaweedWidth: 1.16,
  seaweedSway: 25.73,
  seaweedTipLight: 1.12,
  seaweedDepthFade: 0.52,
};
